export default {"src":"/_next/static/media/ic_cbox_on.e5d3b7df.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};